








































































































































import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
// import gql from 'graphql-tag'
import { DateTime } from 'luxon'

import { Plant, Machine, Area, ReportType, Report } from '../typings'
// import MessageService from '../services/MessageService'
import ActionsMenu from '../components/ActionsMenu.vue'

const NULL = null as any

// const allPlantsQuery = gql`query getPlants {
//   getPlants {
//     id
//     name
//     areas {
//       id
//       name
//       phones
//       reportTypes {
//         id
//         name
//         severity
//       }
//     }
//     machines {
//       id
//       name
//       areas
//     }
//   }
// }`

// const createReportMutation = gql`mutation CreateReport(
//   $creationDate: DateTime!,
//   $assistDate: DateTime,
//   $solvedDate: DateTime,
//   $reportTypeID: ID!,
//   $plantID: ID!,
//   $areaID: ID!,
//   $machineID: ID!,
//   $comment: String!
// ) {
//   createReport(
//     creation_date: $creationDate,
//     assist_date: $assistDate,
//     solved_date: $solvedDate,
//     reportType: $reportTypeID,
//     plant: $plantID,
//     area: $areaID,
//     machine: $machineID,
//     comment: $comment
//   ) {
//     id
//   }
// }`

@Component({
  components: {
    ActionsMenu
  }
  // apollo: {
  //   plants: {
  //     query: allPlantsQuery,
  //     update: data => data.getPlants
  //     // pollInterval: 300 ???
  //   }
  // }
})
export default class Home extends Vue {
  // Plants
  private selectedPlant: Plant = NULL
  private plants: Plant[] = [
    {
      id: '1',
      name: 'Cabezas',
      areas: [
        {
          id: NULL,
          name: 'Tooling',
          phones: NULL,
          reportTypes: [
            { id: NULL, name: 'Maintenance', severity: 5 },
            { id: NULL, name: 'Testing', severity: 3 },
            { id: NULL, name: 'Failure', severity: 9 }
          ]
        },
        {
          id: NULL,
          name: 'Operations',
          phones: NULL,
          reportTypes: [
            { id: NULL, name: 'Maintenance', severity: 5 },
            { id: NULL, name: 'Failure', severity: 9 }
          ]
        }
      ],
      machines: [
        { id: NULL, name: 'Sopladora 105', areas: NULL },
        { id: NULL, name: 'Corregidora 201', areas: NULL }
      ]
    },
    {
      id: '2',
      name: 'Industria',
      areas: [
        {
          id: NULL,
          name: 'Engineering',
          phones: NULL,
          reportTypes: [
            { id: NULL, name: 'Maintenance', severity: 5 },
            { id: NULL, name: 'Testing', severity: 1 },
            { id: NULL, name: 'Failure', severity: 9 }
          ]
        },
        {
          id: NULL,
          name: 'Operations',
          phones: NULL,
          reportTypes: [
            { id: NULL, name: 'Maintenance', severity: 5 },
            { id: NULL, name: 'Failure', severity: 9 }
          ]
        }
      ],
      machines: [
        { id: NULL, name: 'Transformadora 85', areas: NULL },
        { id: NULL, name: 'Forjadora 21', areas: NULL }
      ]
    }
  ]

  // Machines
  private selectedMachine: Machine = NULL
  private machines: Machine[] = NULL

  // Area
  private selectedArea: Area = NULL
  private areas: Area[] = NULL
  readonly areasPlaceholder: Area[] = [
    { id: NULL, name: 'Tooling', phones: NULL, reportTypes: NULL },
    { id: NULL, name: 'Operations', phones: NULL, reportTypes: NULL }
  ]

  // ReportType
  private selectedReportType: ReportType = NULL
  private reportTypes: ReportType[] = NULL
  readonly reportTypesPlaceholder: ReportType[] = [
    { id: NULL, name: 'Maintenance', severity: 5 },
    { id: NULL, name: 'Failure', severity: 9 }
  ]

  // Comment
  private comment = ''
  private showCommentTemplates = false
  private commentTemplates = [
    { comment: 'Preventative maintenance to the operation', edit: false },
    { comment: 'Lack of ', edit: true },
    { comment: 'Change of ', edit: true },
    { comment: '100% progress of inspection', edit: false }
    // { comment: 'Mtto. Preventivo A Operacion' edit: false }, // Mantenimiento
    // { comment: 'Mtto. Correctivo A Operacion' edit: false }, // Mantenimiento
    // { comment: 'Mtto. Preventivo A Herramental' edit: false }, // Mantenimiento
    // { comment: 'Mtto. Correctivo A Herramental' edit: false }, // Mantenimiento
    // { comment: 'Falta De Material Por Falla Operacion Anterior' edit: false }, // Mantenimiento
    // { comment: 'Bloqueada Por Falla De Operacion Siguiente' edit: false }, // Mantenimiento
    // { comment: 'Falta De Herramientas' edit: false }, // Herramientas
    // { comment: 'Cambio De Herramientas' edit: false }, // Herramientas
    // { comment: 'Ajuste Falla De Herramientas' edit: false }, // Herramientas
    // { comment: 'Falta De Material' edit: false }, // MTLS
    // { comment: 'Pruebas De Ingenieria' edit: false }, // Ingenieria
    // { comment: 'Velocidad Reducida' edit: false }, // Ingenieria
    // { comment: 'Retrabajo / Contenciones' edit: false }, // Calidad
    // { comment: 'Inspeccion 100%' edit: false }, // Calidad
    // { comment: 'Calibres' edit: false }, // Calidad
    // { comment: 'Metrologia' edit: false }, // Calidad
    // { comment: 'Cambio De Modelo', edit: false }, // Produccion
    // { comment: 'Juntas', edit: false }, // Produccion
    // { comment: 'Limpieza' edit: false }, // Produccion
    // { comment: 'Causa Especial De Produccion' edit: false }, // Produccion
    // { comment: 'Servicio Medico', edit: false }, // RH
    // { comment: 'Capacitacion', edit: false } // RH
  ]

  private lastSentReport: Report = NULL
  private disableSendButtons = true
  private showErrors = false
  private sendReportStatus = 'success'

  private formErrors = {
    plant: true,
    machine: true,
    area: true,
    reportType: true
  }

  get hasErrors (): boolean {
    const errors = Object.values(this.formErrors)

    for (const error of errors) {
      if (error) {
        return true
      }
    }

    return false
  }

  @Ref('comment') readonly commentTextArea!: Vue

  @Watch('selectedPlant')
  public plantSelected () {
    if (this.selectedPlant) {
      this.machines = this.selectedPlant.machines
      this.areas = this.selectedPlant.areas
      this.selectedMachine = NULL
      this.formErrors.plant = false
    } else {
      this.formErrors.plant = true
    }

    this._checkSendButtons()
  }

  @Watch('selectedMachine')
  public machineSelected () {
    if (this.selectedMachine) {
      this.formErrors.machine = false
    } else {
      this.formErrors.machine = true
    }

    this._checkSendButtons()
  }

  @Watch('selectedArea')
  public areaSelected () {
    const area = this.selectedArea
    if (area) {
      if (area.reportTypes.length !== 0) this.reportTypes = this.sortReportTypes(area.reportTypes)
      this.formErrors.area = false
    } else {
      this.formErrors.area = true
    }

    this._checkSendButtons()
  }

  @Watch('selectedReportType')
  public reportTypeSelected () {
    if (this.selectedReportType) {
      if (!this.comment) this.showCommentTemplates = true
      this.formErrors.reportType = false
    } else {
      this.formErrors.reportType = true
    }

    this._checkSendButtons()
  }

  private log (data: any) {
    console.log(data)
  }

  private _checkSendButtons () {
    if (this.hasErrors) {
      this.disableSendButtons = true
    } else {
      this.disableSendButtons = false
    }
  }

  public sortReportTypes (reportTypes: ReportType[]): ReportType[] {
    return reportTypes.sort((a, b): number => (
      a.severity > b.severity) ? 1 : (a.severity === b.severity) ? ((a.name > b.name) ? 1 : -1) : -1
    )
  }

  public getSeverityStatus (severity: number): string {
    if (severity < 4) {
      return 'info'
    }

    if (severity >= 4 && severity <= 7) {
      return 'warning'
    }

    return 'danger'
  }

  public setCommentInTextarea (text: string, edit: boolean): void {
    this.comment = text
    if (edit) {
      const commentTextArea = this.commentTextArea.$el as HTMLTextAreaElement
      commentTextArea.focus()
    }
    this.showCommentTemplates = false
  }

  public restoreReport () {
    if (this.lastSentReport) {
      this.selectedPlant = this.lastSentReport.plant
      this.selectedMachine = this.lastSentReport.machine
      this.selectedReportType = this.lastSentReport.reportType
      this.comment = this.lastSentReport.comment
    }
  }

  public clearReport () {
    this.disableSendButtons = true
    this._clearInputs()
  }

  private _validateForm () {
    this.formErrors = {
      plant: !this.selectedPlant,
      machine: !this.selectedMachine,
      area: !this.selectedArea,
      reportType: !this.selectedReportType
    }

    this.showErrors = this.hasErrors
  }

  private _animateSendButton (button: HTMLElement, sent: boolean) {
    const animationClass = 'send__button--' + (sent ? 'sent' : 'error')

    button.classList.add(animationClass)
    button.blur()

    // Remove after animation ends to be able to trigger it again
    setTimeout(() => {
      button.classList.remove(animationClass)
    }, 4000)
  }

  private _setSendReportStatus (status: string) {
    this.sendReportStatus = status
  }

  private _sendText (): boolean {
    // const message = `Máquina ${this.selectedMachine.name} de la planta ${this.selectedPlant.name}` +
    //                 `[${this.selectedReportType.name}]\n` +
    //                 `Area ${this.selectedArea.name} notificada` + this.comment ? ` por ${this.comment}` : ''
    let messageSent = false

    // TODO: Send the area as argument to be able to identify to whom we are sending the message
    // MessageService.send(message)
    //   .then((response: any) => {
    //     this.$toast.add({ severity: 'success', summary: 'Mensaje enviado!', detail: response.data, life: 3000 })
    //     messageSent = true
    //   })
    //   .catch((error: any) => {
    //     const errorMessage = error.response ? error.response.data : 'No se pudo conectar con el servidor'
    //     this.$toast.add({ severity: 'error', summary: errorMessage, detail: 'Porfavor intentelo de nuevo', life: 3000 })
    //     messageSent = false
    //   })
    switch (this.sendReportStatus) {
      case 'success':
        this.$toast.add({ severity: 'success', summary: 'Message sent!', life: 5000 })
        // this.$toast.add({ severity: 'success', summary: 'Message sent!', detail: message, life: 5000 })
        messageSent = true
        break
      case 'fail':
        this.$toast.add({ severity: 'error', summary: 'Something went wrong :(', detail: 'Please try again later', life: 5000 })
        messageSent = false
        break
      default:
        break
    }

    return messageSent
  }

  private _clearInputs () {
    this.selectedPlant = NULL
    this.selectedMachine = NULL
    this.selectedReportType = NULL
    this.comment = ''

    this.machines = NULL
    this.areas = NULL
    this.reportTypes = NULL
  }

  // private _saveReport (): Promise<boolean> {
  //   return new Promise(resolve => {
  //     this.$apollo.mutate({
  //       mutation: createReportMutation,
  //       variables: {
  //         creationDate: this.lastSentReport.creation_date,
  //         assistDate: this.lastSentReport.assist_date,
  //         solvedDate: this.lastSentReport.solved_date,
  //         plantID: this.lastSentReport.plant.id,
  //         machineID: this.lastSentReport.machine.id,
  //         reportTypeID: this.lastSentReport.reportType.id,
  //         areaID: this.lastSentReport.area.id,
  //         comment: this.lastSentReport.comment
  //       }
  //       // update: (store: any, { data: { createReport } }: any) => {
  //       //   const data = store.readQuery({ query: allReportsQuery })
  //       //   data.allReports.push(createReport)
  //       //   store.writeQuery({ query: allReportsQuery, data })
  //       // }
  //     }).then(({ data }: any) => {
  //       this.lastSentReport.id = data.createReport.id
  //       console.log(data)
  //       resolve(true)
  //     }).catch((error) => {
  //       console.error(error)
  //       resolve(false)
  //     })
  //   })
  // }

  public async areaButtonClickHandler (event: any) {
    const button = event.target

    this._validateForm()

    if (this.hasErrors) {
      this._animateSendButton(button, false)
      this.disableSendButtons = true
      return
    }

    this.lastSentReport = {
      creation_date: DateTime.local(),
      assist_date: NULL,
      solved_date: NULL,
      plant: this.selectedPlant,
      machine: this.selectedMachine,
      reportType: this.selectedReportType,
      area: this.selectedArea,
      comment: this.comment
    }

    // Send and save report
    this.lastSentReport.sent = this._sendText()
    this._animateSendButton(button, this.lastSentReport.sent)

    // this.lastSentReport.saved = await this._saveReport()

    if (this.lastSentReport.sent || this.lastSentReport.saved) this._clearInputs()

    if (this.lastSentReport.sent) {
      this.showErrors = false
      this.disableSendButtons = true
    } else {
      // Disable send buttons for the duration of the button's animation
      this.disableSendButtons = true
      setTimeout(() => {
        this.disableSendButtons = this.hasErrors
      }, 4000)
    }
  }
}
